import { URLS } from "@/api/urls";

import fetcher_v2 from "../fetcher_v2";

export const setFavorites = (ids: string[], isFavorite: boolean) =>
  fetcher_v2(URLS.FAVORITE, {
    method: "POST",
    body: { favorite: isFavorite, ids },
  });
